import './index.scss'

interface LoadingScreenProps {
  /**
   * Layout footprint.
   * @default 'fullpage'
   */
  variant?: 'fullpage' | 'inline'
  /**
   * Palette. 'dark' matches dark routes (app-layout--dark, $bg-dark) so the shimmer doesn't flash.
   * @default 'light'
   */
  tone?: 'light' | 'dark'
}

export function LoadingScreen({ variant = 'fullpage', tone = 'light' }: LoadingScreenProps) {
  return (
    <div className={`loading-screen loading-screen--${variant} loading-screen--${tone}`}>
      <div className="loading-screen__shimmer" />
    </div>
  )
}

// Default export for convenience
export default LoadingScreen
